import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_INCOME_SOURCES_QUERY = gql`
  query pagedIncomeSources($pager: PagerInputNew, $filters: IncomeSourcesFilterInput) {
    pagedIncomeSources(pager: $pager, filters: $filters) {
      total
      values {
        ...incomeSource
      }
    }
  }
  ${Fragments.incomeSource}
`;
